export default {

    // Top-level: UserInfo.vue reads $t('shared.unknown_user'). The only copy
    // of this key used to live nested under `survey.`, so that lookup missed
    // and the feed showed the literal string "shared.unknown_user".
    unknown_user: 'Unknown user',
    media_unavailable: 'Media unavailable',
    media_load_failed: 'Media could not load.',
    retry: 'Retry',

    survey: {
        get_started: 'Get Started',
        guest_join_prompt_prefix: 'You are joining as a guest. Do you want to ',
        login: 'Login',
        request_fallback: 'Request',
        description_fallback: 'Please complete this request',
        created_by: 'Created by',
        creator_alt: 'Creator',
        unknown_creator: 'Unknown Creator',
        unknown_user: 'Unknown user',
        user_fallback: 'User',
        loading: 'Loading...',
        loading_request: 'Loading request...',
        error: 'Error',
        cover_image_alt: 'Request cover image',
        logo_alt: 'logo',
        starting_request: 'Starting Request...',
        start_request: 'Start Request',
        click_to_begin: 'Click to begin answering the request',
        enter_email_required: 'Enter your email (Required)',
        // NOTE: vue-i18n message compiler treats "@" as linked-message syntax.
        // Keep the actual "@" injected via params to avoid compilation errors.
        email_placeholder: 'your.email{at}example.com',
        checking_user: 'Checking user...',
        first_name: 'First Name',
        first_name_placeholder: 'First name',
        last_name: 'Last Name',
        last_name_placeholder: 'Last name',
        job_title: 'Job Title',
        job_title_placeholder: 'Your job title',
        company: 'Company',
        company_placeholder: 'Company name',
        terms_prefix: 'By continuing, you agree to MarketScale\'s',
        terms_link_text: 'Terms and Conditions',
        accept_additional_terms_prefix: 'I accept the',
        accept_additional_terms_suffix: 'Additional Terms',
        additional_terms_blurb: 'These Additional Terms apply only to this request. In the event of a conflict, MarketScale\'s Terms of Service govern your use of MarketScale\'s platform, and these Additional Terms govern only your participation in this request.',
        submitting: 'Submitting...',
        submit: 'Submit',
        loading_requestjs: 'Loading RequestJS...',
        loading_request_component: 'Loading request component...',
        next: 'Next',
        back_to_question: 'Back to question {number}',
        continue: 'Continue',
        almost_done: 'Almost done.',
        closing_sub: 'A few details so {company} can follow up.',
        closing_confirm_sub: 'Confirm who this response is from, then send to {company}.',
        responding_as: 'Responding as',
        the_team: 'the team',
        send_response: 'Send your response',
    },

    // users.title
    users: {
        title: 'User & Channel Management',
        allUsersTitle: 'All Users',
        action_buttons: {
            create: 'Create User',
            invite: 'Invite User'
        },
        inputSearch: 'Search',
        perPage: 'Users per page',
        perPageLabel: 'Users per page',
        perPageHint: 'How many users to show on each page',
        paginationRange: 'Showing {from}–{to} of {total}',
        tabs: {
            users: {
                route: 'users',
                text: 'Users'
            },
            organizations: {
                route: 'organizations',
                text: 'Channels'
            },
            domains: {
                route: 'companies',
                text: 'Domains'
            }
        },
        table: {
            header: {
                name: 'Name',
                title: 'Title',
                email: 'Email',
                department: 'Department',
                company: 'Company',
                organization: 'Channel',
                role: 'Role',
                status: 'Status',
                edit: 'Edit',
                actions: 'Actions',
                viewAs: 'View As',
                resendInvite: 'Resend Invite'
            },
            columns: {
                role: {
                    disabledTooltip: 'Only MS Admins can change this role'
                },
                edit: 'Edit',
                recover: 'Recover',
                permanentDelete: 'Permanent delete',
                resendInvite: 'Resend Invite'
            },
            noUsersFound: 'No users found'
        },
        edit_role: {
            title: 'Edit User Role',
            selectRole: 'Select a user role for the user.',
            removeFromOrganization: 'Remove from channel',
            removeUser: 'Remove User',
            removeFromOrganizationDescription: 'This will remove the user from your channel. They can be re-invited later.',
            deleteUser: 'Delete user',
            deleteUserDescription: 'Permanently remove this member from your MarketScale Studio. Please note that this action cannot be undone',
            deleteUserDescriptionChannel: 'Removes this user from your channel and moves them to the Deleted tab. You can restore them from there later.',
            msAdminDisabledTooltip: 'Only active users and MarketScale users can be set as MS Admins',
            adminDisabledTooltip: 'Only active users can be set as Admins',
            msAdminFloorTooltip: 'MarketScale teammates are always MS Admin on every channel',
        },
        filter_by_org: {
            title: 'Filter by Channel',
            searchInputPlaceholder: 'Search channels...',
            cancel: 'Cancel',
            save: 'Save',
            loadMore: 'Load more'
        },
        filter_by_role: {
            title: 'Filter by Role',
            cancel: 'Cancel',
            save: 'Save'
        },
        filter_by_status: {
            title: 'Filter by Status',
            cancel: 'Cancel',
            save: 'Save'
        },
        filter_by_type: {
            title: 'Filter by Type',
            cancel: 'Cancel',
            save: 'Save'
        },
        filter_by_latest: {
            title: 'Sort by',
            cancel: 'Cancel',
            save: 'Save'
        },
        alert_modal_restore: {
            title: 'Confirm Restoration',
            text: 'Are you sure you want to restore this user to your MarketScale Studio? Restoring this user will reactivate their access and associated content.',
            showIcon: 'yellow',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Restore',
        },
        alert_modal_restore_channel: {
            title: 'Confirm Restoration',
            text: 'Are you sure you want to restore this user\'s access to your channel?',
            showIcon: 'yellow',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Restore',
        },
        /** All Users (soft-deleted user): hard-deletes the user record. */
        alert_modal_hide_from_deleted_list: {
            title: 'Permanently delete user?',
            text: 'This permanently deletes the user from the database. This action cannot be undone.',
            showIcon: 'red',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Permanently delete',
        },
        /** Members page Deleted tab: force-removes organisation_users row; assets reassigned to acting admin. */
        alert_modal_permanent_remove_channel_member: {
            title: 'Permanently delete this user?',
            text: "This user will be permanently removed from your organization and cannot be restored. The user's content will be reassigned to you.",
            showIcon: 'red',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Permanently delete',
        },
        alert_modal_remove: {
            title: 'Confirm Removal',
            text: 'Are you sure you want to remove this user from your MarketScale Studio? They will lose access but can be re-invited later.',
            showIcon: 'red',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Remove',
        },
        alert_modal_delete: {
            title: 'Confirm Deletion',
            text: 'Are you sure you want to permanently delete this user from your MarketScale Studio? This action cannot be undone.',
            showIcon: 'red',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Delete',
        },
        alert_modal_delete_channel: {
            title: 'Delete user?',
            text: 'They will be removed from this channel and appear under the Deleted tab. You can restore them later from there.',
            showIcon: 'red',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Delete',
        }
    },

    domains: {
        inputSearch: 'Search',
        action_buttons: {
            create: 'Create Domain'
        },
        table: {
            header: {
                name: 'Name',
                domain: 'Domain',
                addedBy: 'Created by',
                status: 'Status',
                users: 'Total Users',
                edit: 'Edit',
                activate: 'Activate',
                remove: 'Remove'
            },
            status: {
                Public: 'Restricted',
                Private: 'Trusted'
            },
            noDomainsFound: 'No domains found'
        },
        alert_modal_create: {
            title: 'Add a Trusted Domain',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Add Domain',
            domainLabel: 'Domain address',
            domainText: 'Enter the domain you want to allow (no {symbol} needed).',
            domainInputPlaceholder: 'e.g. marketscale.com',
            domainInputInvalidFormat: 'Enter domain name (e.g., marketscale.com), without the {symbol} symbol and no spaces.',
            domainInputMissingExtension: 'Please enter a valid domain with an extension (e.g., .com, .org).',
            selectDomainLabel: 'Select a Domain Type',
            trustedDomainLabel: 'Trusted',
            trustedDomainText: 'For owned company domains like <i>yourcompany.com</i>. Users with matching email addresses will automatically be added as <strong>Standard</strong> users.',
            restrictedDomainLabel: 'Restricted',
            restrictedDomainText: 'For domains you don\'t own (such as gmail.com or outlook.com). Users registering with these domains will automatically receive <strong>VIP Guest Pass</strong> access.',
            domainTypeRequired: 'Please select a domain type',
            addedToChannelLabel: 'Add domain to channel: '
        },
        alert_modal_edit: {
            title: 'Edit Domain',
            remove: 'Delete Domain',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Update',
            domainLabel: 'Domain address',
            domainText: 'Enter the domain you want to allow (no {symbol} needed).',
            domainInputPlaceholder: 'e.g. marketscale.com',
            domainInputInvalidFormat: 'Enter domain name (e.g., marketscale.com), without the {symbol} symbol and no spaces.',
            domainInputMissingExtension: 'Please enter a valid domain with an extension (e.g., .com, .org).',
            selectDomainLabel: 'Select a Domain Type',
            trustedDomainLabel: 'Trusted',
            trustedDomainText: 'For owned company domains like <i>yourcompany.com</i>. Users with matching email addresses will automatically be added as <strong>Standard</strong> users.',
            restrictedDomainLabel: 'Restricted',
            restrictedDomainText: 'For domains you don\'t own (such as gmail.com or outlook.com). Users registering with these domains will automatically receive <strong>VIP Guest Pass</strong> access.',
            domainTypeRequired: 'Please select a domain type',
        },
        alert_modal_remove: {
            title: 'Remove Domain',
            text: 'Are you sure you want to permanently delete this domain? This action cannot be undone.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Remove'
        },
        alert_modal_remove_from_channel: {
            title: 'Remove Domain from Channel',
            text: 'Are you sure you want to remove this domain from this channel?',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Remove'
        }
    },

    memories: {
        inputSearch: 'Search',
        alert_modal_create: {
            title: 'Create Memory',
            descriptionLabel: 'Description',
            descriptionInputPlaceholder: 'Enter a description for your memory',
            descriptionInputRequired: 'Enter a description for your memory',
            descriptionInputTooLong: 'The description may not be greater than 255 characters.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Create'
        },
        alert_modal_remove: {
            title: 'Are you sure you want to delete this memory?',
            text: 'It will be removed from your Brand Brain, but can be recovered later if needed.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Remove'
        },
        alert_modal_approve: {
            title: 'Approve Memory',
            text: 'Are you sure you want to approve this memory?',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Approve'
        },
        alert_modal_restore: {
            title: 'Do you want to recover this memory?',
            text: 'It will return to your Brand Brain immediately and become available for use again.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Restore'
        },
        filter_by_people: {
            title: 'Filter by People',
            searchInputPlaceholder: 'Search people...',
            cancel: 'Cancel',
            save: 'Save',
            loadMore: 'Load more'
        }
    },

    people: {
        inputSearch: 'Search',
    },

    channels: {
        title: 'User & Channel Management',
        breadcrumb: 'Channels',
        action_buttons: {
            createOrganization: 'Create Channel'
        },
        inputSearch: 'Search',
        table: {
            header: {
                name: 'Name',
                id: 'ID',
                createdBy: 'Created by',
                zone: 'Zone',
                domains: 'Domains',
                users: 'Total Users',
                status: 'Status',
                edit: 'Edit',
                view: 'View'
            },
            noOrganizationsFound: 'No channels found'
        },
        alert_modal_create: {
            title: 'Create Channel',
            nameLabel: 'Channel name',
            nameInputPlaceholder: 'Channel name',
            nameInputRequired: 'Enter a name for your channel',
            nameInputTooLong: 'The name may not be greater than 45 characters.',
            websiteInputInvalid: 'That does not look like a website. Try acme.com',
            descriptionLabel: 'Description',
            descriptionInputPlaceholder: 'Tell me about your company...',
            descriptionInputRequired: 'Enter a description for your channel',
            descriptionInputTooLong: 'You have entered the maximum number of characters allowed.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Create'
        },

        alert_modal_invite_user: {
            title: 'Invite User',
            emailLabel: 'User Email',
            emailText: 'Please provide the email address you wish to permit access',
            emailInputPlaceholder: 'e.g., user',
            emailInputPlaceholder2: 'marketscale.com',
            emailInputRequired: 'Enter an email to invite a user.',

            rolesLabel: 'Roles',
            vipRoleLabel: 'VIP Guest Pass',
            vipRoleText: 'For users signing up with personal or unverified domains (like gmail.com or outlook.com). These users receive limited access, perfect for external collaborators, clients, or short-term contributors.',
            standardRoleLabel: 'Standard',
            standardRoleText: 'Automatically assigned to users from verified company domains (e.g., yourcompany.com). Standard users are considered internal team members with full access to essential tools.',
            adminRoleLabel: 'Admin',
            adminRoleText: 'For users needing advanced permissions to manage people, projects, or platform settings. Admins have greater control than Standard users and can oversee team workflows.',
            msAdminRoleLabel: 'MarketScale Admin',
            msAdminRoleText: 'Highest-level access reserved for MarketScale personnel only. These users can configure the platform, manage all channels, and oversee system-wide settings.',

            roleTypeRequired: 'Please select a role type',
            msAdminFloorTooltip: 'MarketScale teammates are always MS Admin on every channel',

            buttonCancel: 'Cancel',
            buttonSubmit: 'Invite User'
        },

        edit: {
            aside: {
                jumpToSection: 'Jump to Section',
                organizationInformation: 'Channel Info',
                aiPrompt: 'AI Prompt',
                organizationBranding: 'Channel Branding',
                teamManagement: 'Team Management',
                emailDomains: 'Trusted Domains',
                adminSettings: 'MarketScale Admin Settings',
                approvalSettings: 'Approval Settings',
                dangerZone: 'Danger Zone',
            },
            organizationInformation: {
                breadcrumb: 'Channel Info',
                title: 'Channel Information',
                parapgraph: 'Update your channels information, manage domains, and personalize AI behavior.',
                name: 'Channel Name',
                industry: 'Industry',
                orgId: 'Channel ID',
                location: 'Location',
                address: 'Address',
                website: 'Website',
                description: 'Description',
                city: 'City',
                state: 'State',
                postalCode: 'Postal Code',

                nameInputRequired: 'Enter a name for your channel',

                action_buttons: {
                    update: 'Update',
                    cancel: 'Cancel',
                }
            },
            aiPrompt: {
                title: 'Hub AI Prompt',
                parapgraph: 'The Channel AI Prompt customizes how AI Writer and AI Editing Direction generate content—ensuring it reflects your channel tone, style, and objectives.',
                promptPlaceholder: 'Add brand tone, voice guidelines, or content rules to guide AI responses for this channel...',
            },
            organizationBranding: {
                breadcrumb: 'Hub Info',
                title: 'Hub Branding',
                parapgraph: 'Customize how your Channel looks to users across web and email.',
                feedLogo: 'Feed Logo',
                feedLogoDescription: 'Displayed on a colored background.',
                emailLogo: 'Logo',
                emailLogoDescription: 'Displayed on a white background.',

                action_buttons: {
                    brandBook: 'Brand Books',
                    replaceImage: 'Replace Image',
                    remove: 'Remove',
                    uploadImage: 'Upload Image',
                },

                themeColor: 'Theme Color',
                themeColorDescription: 'These backgrounds will be available for all users in your channel',

                virtualBackgrounds: 'Camera Virtual Backgrounds',
                virtualBackgroundDescription: 'The virtual background for your channel.',

                virtualBackground1: 'Virtual Background',
                virtualBackground2: 'Virtual Background',
            },

            teamManagement: {
                title: 'Team Management',
                description: 'Invite new users to join this channel and manage team access.',

                action_buttons: {
                    viewUsers: 'View Users',
                    inviteUser: 'Invite User',
                    createUser: 'Create User',
                }
            },

            emailDomains: {
                title: 'Trusted Domains',
                description: 'Users with these domains will have Standard permissions in your channel.',

                action_buttons: {
                    addDomain: 'Add Domain',
                }
            },

            adminSettings: {
                title: 'MarketScale Admin Settings',
                description: 'Only visible for MarketScale Admins.',

                accessLevel: 'Access Level',
                editZone: 'Editing Zone',
                parentName: 'Parent name',
                mediaApprovers: 'Media Approvers',

                accessLevelOptions: {
                    // Doctrine tiers (canonical)
                    diamond: 'Diamond',
                    platinum: 'Platinum',
                    gold: 'Gold',
                    silver: 'Silver',
                    bronze: 'Bronze',
                    smb_tier: 'SMB',
                    below_smb: 'Below SMB',
                    // Permanent free plan
                    free_forever: 'Free Forever',
                    // Paid plans
                    basic: 'Basic',
                    scale: 'Scale',
                    business: 'Business',
                    enterprise: 'Enterprise',
                    // Deprecated / interim tiers
                    ultra: 'Ultra (deprecated)',
                    elite: 'Elite (deprecated)',
                    smb: 'SMB (deprecated)',
                    freemium: 'Freemium (deprecated)',
                },

                // Trial-gating copy (doctrine UX Rules)
                trialGating: {
                    aiVisibilityIncluded: 'AI Visibility is included with your trial.',
                    aiVisibilityLocked: 'AI Visibility is available on select MarketScale plans. Your current trial does not include access.',
                    aiVisibilityUnavailable: 'AI Visibility is not available for this account.',
                    ovbCard: 'On-site video booking is available in MarketScale. Trial accounts may submit interest, but booking is not active until approved.',
                    ovbFormBanner: 'You are currently on a trial version. This request will be reviewed, but on-site video booking is not active for your account yet.',
                    ovbSubmit: 'Submit request for review',
                    ovbSubmitManual: 'Submit interest for review',
                    ovbConfirmation: 'Request received. Your account team will review whether on-site video booking can be activated for this trial.',
                    ovbUnavailable: 'This feature is not active for this account.',
                },

                mediaApproversOptions: {
                    allUsers: 'All Users',
                    adminsOnly: 'Admins Only',
                    adminsStandard: 'Admins + Standard',
                    custom: 'Custom',
                    customPickerPlaceholder: 'Search channel members…',
                    customPickerHeader: 'Channel members',
                    customSelectedCount: '{count} selected',
                    customEmptyHint: 'No custom approvers selected — only admins can approve.',
                },

                ms: {
                    organization: 'MarketScale Channel',
                    organizationDescription: 'This makes the Channel dependent on MarketScale.',
                    topShelf: 'Top Shelf Channel',
                    topShelfDescription: 'Makes the Channel edits exclusive for Top Shelf editors.',
                    setupMode: 'Enable Setup Mode',
                    setupModeDescription: 'Activates Channel and limits access to the onboarding steps.',
                    aiVisibility: 'Enable AI Visibility',
                    aiVisibilityDescription: 'Activate AI Visibility for this channel',
                    turnOffAi: 'Turn Off AI',
                    turnOffAiDescription: 'Disable generative AI features (AI QC, AI Writer, AI Edit Request, AI Docs, AI Translations, survey response summaries and key points) for this channel. Transcription, captions, and dynamic pricing remain enabled.',
                    revisionCheckpoint: 'Revision Checkpoint',
                    revisionCheckpointDescription: 'Only MarketScale Users will be able to request revisions on projects past version 2.0.',
                }
            },

            approvalSettings: {
                title: 'Approval Settings',
                description: 'Control how recorded and uploaded content is approved in this channel.',
                inboxEnabled: 'Approval Inbox',
                inboxEnabledDescription: 'When on, recorded and uploaded content waits for approval. When off, content is published immediately and skips the queue.',
            },

            newsPreferences: {
                title: 'News Preferences',
                subtitle: 'Define industries and tone for news feed generation.',
                tone: 'Tone',
                description: 'Description',
                create: 'Create preference',
                industry: 'Industry',
                createdBy: 'Created by',
                updated: 'Last updated',
                timesUsed: 'Times used',
                enabled: 'Enabled',
                empty: 'No preferences yet',
            },

            dangerZone: {
                title: 'Danger Zone',
                description: 'Only visible for Super Admins.',

                action_buttons: {
                    deactivateOrganization: 'Deactivate Channel',
                }
            },

            deactivateOrganizationModal: {
                title: 'Confirm channel deactivation',
                description: 'The channel goes offline for everyone and stops publishing. Nothing is deleted - you can restore it anytime from Channel Settings or using the restore link sent by email.',
                buttonCancel: 'Cancel',
                buttonSubmit: 'Deactivate',
            }
        }
    },

    tasksListPage: {
        title: 'Workbench',
        tabs: {
            all: 'All',
            myTasks: 'My To-Dos',
            channelTasks: 'Channel To-Dos',
            createdByMe: 'Created by Me',
            campaigns: 'Campaigns',
        },
        action_buttons: {
            createCampaign: 'Create Campaign',
            newTask: 'New To-Do',
            managePlaybooks: 'Playbooks',
        }
    },

    campaigns: {
        modalCreate: {
            title: 'Create New Campaign',
            titleLabel: 'Campaign Title',
            titlePlaceholder: 'Enter campaign title',
            descriptionLabel: 'Campaign Description',
            descriptionPlaceholder: 'Enter campaign description',
            startDateLabel: 'Start Date',
            dueDateLabel: 'Due Date',
            assigneeLabel: 'Assignee',
            priorityLabel: 'Priority',
            action_buttons: {
                cancel: 'Cancel',
                createCampaign: 'Create Campaign',
                creating: 'Creating...',
            },
            error: {
                campaignTitleRequired: 'Campaign title is required'
            }
        }
    },

    workbench: {
        backToWorkbench: 'Back to Workbench',
        title: 'The Workplace - ',
        copyLink: 'Copy link',
        assigneeDropdown: {
            selectUser: 'Select user',
            selectUserPlaceholder: 'Search users...',
            unassign: 'Unassign',
            unassignDescription: 'Remove current assignee',
            noUsersFound: 'No users found',
            noUserId: 'Unknown User with ID: ',
        },
        priorityDropdown: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
            urgent: 'Urgent',
        },
        datePicker: {
            startDate: 'Set start date',
            dueDate: 'Set due date',
            selectDate: 'Select date'
        },
        checklist: {
            title: 'Checklist',
            empty: 'No checklist items',
            addItem: 'Add checklist item...',
            itemPlaceholder: 'Enter item...',
            progress: '{completed} of {total} completed',
        },
        mobileMenu: {
            menu: 'Menu',
            markCompleted: 'Mark Completed',
            editNow: 'Edit Now',
        },
        statuses: {
            new: 'New',
            inProgress: 'In progress',
            paused: 'Paused',
            completed: 'Completed',
            canceled: 'Canceled',
        },
        files: {
            title: 'Additional files',
            addFiles: 'Attach files',
            uploading: 'Uploading...',
            back: 'Back',
            logs: 'Activity',
            emptyState: {
                text: 'Upload files like scripts, media, or supporting documents.'
            },
            modalDeleteFile: {
                title: 'Delete File',
                text: 'Are you sure you want to delete this file? This action is irreversible.',
                buttonCancel: 'Cancel',
                buttonSubmit: 'Yes, delete ',
            },
            modalDelete: {
                title: 'Confirm',
                title1: 'deletion',
                text: 'Are you sure you want to delete this',
                text1: 'This action is irreversible.',
                buttonCancel: 'Cancel',
                buttonSubmit: 'Yes, delete ',
            }
        },
        modalInfo: {
            title: 'Workbench',
            text: 'Manage your project tasks, messages, and files in one centralized workspace.',
            buttonSubmit: 'OK'
        },
        logs: {
            title: 'Project Logs',
            back: 'Back',
            dates: {
                justNow: 'Just now'
            },
            emptyState: {
                text: 'No logs available',
            }
        },
        messageBoard: {
            title: 'Message Board',
            addMessage: 'Add message',
            reply: 'Reply',
            replyPlaceholder: 'Write a reply...',
            messageInputPlaceholder: 'Write a comment or update...',
            submit: 'Submit',
            emptyState: {
                text: 'Add your first message or project update.'
            }
        },
        task: {
            markCompleted: 'Mark completed',
            completed: 'Completed',
            editNow: 'Edit Now',
            title: 'Task',
            titlePlaceholder: 'Enter task title...',
            description: 'Description',
            descriptionPlaceholder: 'Enter task description...',
            activity: {
                title: 'Task Activity',
            },
            meta: {
                assignee: 'Assignee',
                priority: 'Priority',
                startDate: 'Start Date',
                dueDate: 'Due Date',
                campaign: 'Campaign',
            },
            checklist: {
                title: 'Checklist',
                empty: 'No checklist items',
                addItem: 'Add checklist item...',
                itemPlaceholder: 'Enter item...',
            },

            table: {
                header: {
                    assignee: 'Assignee',
                    priority: 'Priority',
                    start: 'Start',
                    due: 'Due',
                }
            },

            monthNames: {
                january: 'January',
                february: 'February',
                march: 'March',
                april: 'April',
                may: 'May',
                june: 'June',
                july: 'July',
                august: 'August',
                september: 'September',
                october: 'October',
                november: 'November',
                december: 'December',
            },

            action_buttons: {
                cancel: 'Cancel',
                update: 'Update',
                updating: 'Updating…',
            },
            toasts: {
                assigneeChanged: 'Assigned user was changed!',
                assigneeChangeFailed: 'Could not change the assigned user.',
                updated: 'To-Do was updated!',
                updateFailed: 'Could not update the to-do.',
            },
            modalNotFound: {
                title: 'To-Do not found',
                text: 'To-Do with ID ',
                text1: ' was not found in this workbench.',
                buttonSubmit: 'OK',
            },
            modalError: {
                title: 'Error',
                text: 'Unable to load to-do. Please try again.',
                buttonSubmit: 'OK',
            }
        },
        tasks: {
            newTask: 'New To-Do',
            titlePlaceholder: 'Enter to-do title...',
            descriptionPlaceholder: 'Enter to-do description...',
            search: {
                placeholder: 'Search to-dos...',
                noResults: 'No to-dos found matching your search.',
                clearSearch: 'Clear search',
            },
            action_buttons: {
                cancel: 'Cancel',
                update: 'Update',
            },

            table: {
                header: {
                    assignee: 'Assignee',
                    priority: 'Priority',
                    start: 'Start',
                    due: 'Due',
                    details: 'Details',
                },
                actionsDropdown: {
                    copyLink: 'Copy link',
                    duplicateTask: 'Duplicate to-do',
                    deleteTask: 'Delete to-do',
                },
                emptyState: 'Add your to-dos to help complete this project.'
            },

            campaign: {
                placeholder: 'Add to a campaign',
            },

            modalCreate: {
                myTasksTitle: 'My To-Dos',
                channelTasksTitle: 'Channel To-Dos',
                projectTasksTitle: 'Project To-Dos',
                title: 'Create New To-Do',
                titleLabel: 'To-Do Title',
                titlePlaceholder: 'Enter to-do title',
                descriptionLabel: 'To-Do Description',
                descriptionPlaceholder: 'Enter to-do description',
                startDateLabel: 'Start Date',
                dueDateLabel: 'Due Date',
                assigneeLabel: 'Assignee',
                priorityLabel: 'Priority',
                campaignLabel: 'Campaign',
                campaignPlaceholder: 'Add to a campaign',
                checklistLabel: 'Checklist (Optional)',
                action_buttons: {
                    cancel: 'Cancel',
                    createTask: 'Create To-Do',
                    creating: 'Creating...',
                },
                error: {
                    taskTitleRequired: 'To-do title is required',
                    dueDateBeforeStartDate: 'Due date cannot be before start date'
                }
            }
        }
    },

    proofing: {
        tabs: {
            todo: {
                route: 'users',
                text: 'Editing To-Do List',
            },
            transcription: {
                route: 'organizations',
                text: 'Transcription',
            },
        },
        table: {
            emptyState: 'No items to display',
        }
    },

    breadcrumbs: {
        backToFeed: 'Back to feed',
        back: 'Back',
    },

    content: {
        upload: {
            rawFootage: {
                title: 'Raw Footage',
                tooltip: 'Route to folder only. This content will not appear on the main feed.',
                message: 'Upload content will be treated as Raw Footage'
            }
        }
    },

    navbar: {
        dropdown: {
            title: 'Settings',
            settings: 'Settings',
            editProfile: 'Edit Profile',
            editOrganization: 'Edit Channel',
            editChannelName: 'Edit {name}',
            editChannel: 'Channel Settings',
            switchAccount: 'Switch channel',
            searchChannels: 'Search channels',
            switchChannelFailed: 'Could not switch channel. Refresh the page to see your current channels.',
            workspace: 'Workspace',
            taskPlaybooks: 'Task Playbooks',
            brandBrainSavedOrders: 'Brand Brain',
            aiQcDashboard: 'AI QC Dashboard',
            dynamicPricing: 'Dynamic Pricing',
            editorInvoiceSummary: 'Editor Invoice Summary',
            clientServices: 'Client Services',
            operationsPortal: 'Operations Portal',
            editorRates: 'Editor Rates',
            chatFeedback: 'Chat Feedback',
            announcements: 'Announcements',
            privacy: 'Privacy',
            terms: 'Terms',
            logout: 'Logout',
            helpAndSupport: 'Help & Support',
            role: {
                admin: 'Admin',
                msAdmin: 'MS Admin',
                vipGuestPass: 'VIP Guest Pass',
                standard: 'Standard'
            }
        },
        videoStatus: 'Content Tracker',
        notifications: {
            title: 'Notifications',
            inboxRequests: 'You have {count} approval requests'
        },
        menu: {
            inviteUsers: 'Invite Users',
            inviteLinks: 'Invite Links',
            inbox: 'Inbox',
            notifications: 'Notifications',
            videoStatus: 'Content Tracker',
            groups: 'Groups',
            gallery: 'Gallery',
            folders: 'Folders',
            studioMail: 'Studio Mail',
            leads: 'Submit Lead',
            qualifiedLeads: 'Qualified Leads',
            helpAndSupport: 'Help & Support',
            logout: 'Log Out'
        },
        admin: {
            title: 'Admin',
            users: 'Manage Users',
            domains: 'Domains',
            brandBooks: 'Brand Books & Saved Orders'
        },
        msAdmin: {
            title: 'MarketScale Admin',
            // Sub-section labels (grouped layout)
            sectionDirectory: 'Directory',
            sectionProduction: 'Production',
            sectionQualityHealth: 'Quality & Health',
            sectionBusinessOps: 'Business Ops',
            sectionSupport: 'Support',
            // Items
            allUsers: 'All Users',
            allChannels: 'All Channels',
            companies: 'Companies',
            editingQueue: 'Video Editing Queue',
            taskBoard: 'Task Board',
            onsiteVideoBooking: 'Onsite Booking Queue',
            ratingsAndFeedback: 'Ratings & Feedback',
            submitTicket: 'Submit Ticket',
            tickets: 'Tickets',
            studioHealth: 'Studio Health',
            serviceHealth: 'Service Health'
        },
        channel: {
            title: 'Channel',
            channels: 'Channels',
            chooseChannel: 'Choose channel',
            members: '{count} {member}',
            member: 'member',
            members_plural: 'members',
            editChannel: 'Edit Channel',
            search: 'Search',
            goBack: 'Go Back',
            scrollMore: 'Scroll down to view more channels',
            noChannelsFound: 'No channels found.'
        },
        companies: {
            title: 'Companies',
            chooseCompany: 'Choose Company',
            members: '{count} {member}',
            member: 'member',
            members_plural: 'members',
            noCompaniesFound: 'There are no companies.'
        },
        group: {
            title: 'Groups',
            chooseGroup: 'Choose Group',
            members: '{count} {member}',
            member: 'member',
            members_plural: 'members',
            exploreGroups: 'Explore groups',
            search: 'Search',
            goBack: 'Go Back',
            scrollMore: 'Scroll down to view more groups',
            andMore: 'and {count} more'
        },
        balance: {
            title: 'Channel balance',
            credits: '{count} {credit}',
            credit: 'credit',
            credits_plural: 'credits',
            viewTransactions: 'View transactions'
        },
        viewingAs: {
            title: 'Viewing as {name}',
            leave: 'Leave impersonation'
        }
    },

    feed: {
        filter_section: {
            filter: 'Filter',
            sort_by: 'Sort by',
            sort_by_latest: 'Latest',
            sort_by_oldest: 'Oldest',
            type: 'Type',
            status: 'Status',

            statuses: {
                available: 'Available for Editing',
                // Wording is the Editing Queue's own tab label, matched by the proofing
                // room's chip (MediaStudio PIPELINE_STAGE_LABELS) — keep all three identical.
                ready: 'Ready to edit',
                // Same three-way match. The Editing Queue's tab and Media Studio's chip
                // both say "Under Review"; the internal key stays `need-information`
                // (EditingQueueService's bucket name), which is why the two differ here.
                need_information: 'Under Review',
                editing: 'In Editing',
                quality_control: 'Quality Control',
                // The card badge's label for QC-accepted work awaiting the customer,
                // matching Media Studio's chip and the Video Tracker tab.
                delivered: 'Delivered',
                completed: 'Edited',
                final_completed: 'Completed'
            },

            types: {
                media: 'My Media',
                video: 'Video',
                conversation: 'Conversation'
            },

            latest: {
                recent: 'Latest',
                oldest: 'Oldest',
                approval_date: 'Approval Date',
                date_requested: 'Date Requested'
            }
        }
    },

    alertModal: {
        notes_max_length: 'This field cannot contain more than {max} characters.',
    },

    // A
    addMembers: 'Add members',
    aiQcDashboard: 'AI QC Dashboard',
    aiVisibility: 'AI Visibility',
    anInvitationEmailHasSent: 'An invitation email has been sent',
    anInvitationEmailHasSentText: 'VIP Guest Pass will receive an email on your behalf with instructions on how to join the Studio.',
    anInvitationEmailsHaveSent: 'Invitation emails have been sent',
    anInvitationEmailsHaveSentText: 'VIP Guest Pass will receive emails on your behalf with instructions on how to join the Studio.',
    anInvitationEmailsHaveSentTextUser: 'User will receive an email on your behalf with instructions on how to join the Studio.',
    anInvitationEmailsHaveSentTextUsers: 'Users will receive emails on your behalf with instructions on how to join the Studio.',
    approvalQueue: 'Approval Queue',
    approve: 'Approve',
    author: 'Author',

    // B
    back: 'Back',
    bookOnsiteVideoProduction: 'Book Onsite Video Production',
    bookProduction: 'Book a Production',
    brandBooks: 'Brand Books',

    // C
    cancel: 'Cancel',
    clientServices: 'Client Services',
    close: 'Close',
    community: 'Community',
    // The page name: navbar entry, both breadcrumbs, both headings, and — since
    // SM-9272 — the URL (/content-tracker, /content-tracker/tasks). videoTracker /
    // taskTracker below name the two VIEWS inside it (the ContentTrackerToggle
    // labels), not the page.
    contentTracker: 'Content Tracker',
    contentTrackerDescription:
        'Follow everything you\'ve sent to the editing team, from request through to delivery: video edits and quick one-off projects.',
    copyLinkToMedia: 'Copy link to media',
    create: 'Create',
    createNewBrandBook: 'Create New Brand Book',
    createRecordingRoom: 'Create Recording Room',
    createUser: 'Create User',

    // D
    dashboard: 'Dashboard',
    delete: 'Delete',
    deleteGroup: 'Delete group',
    deselectAllMedia: 'Deselect All Media',
    download: 'Download',
    duplicate: 'Duplicate',
    dynamicPricing: 'Dynamic Pricing',

    // E
    edit: 'Edit',
    editingQueue: 'Editing Queue',
    editorInvoiceSummary: 'Editor Invoice Summary',
    emailDomain: 'Email domain',
    enterFirstNamePlaceholder: 'Enter first name',
    enterPassword: 'Enter password',
    enterTitlePlaceholder: 'Enter title',
    error: 'Error',
    expertThoughtLeader: 'Expert Thought Leader',

    // F
    feedback: 'Feedback',
    folders: 'Folders',

    // G
    gallery: 'Gallery',

    // H
    howItWorks: 'How it works:',

    // I
    invite: 'Invite',

    // J
    join: 'Join',

    // L
    linkExpired: 'Link expired',
    loadMore: 'Load more',
    login: 'Log in',

    // M
    myChannel: 'My channel',
    myGroups: 'My groups',

    // N
    noCancel: 'No, cancel',
    noUsersFound: 'No users found',

    // O
    ok: 'OK',
    onsiteVideoBookingQueue: 'Onsite Video Booking Queue',
    operationsPortal: 'Operations Portal',

    // P
    password: 'Password',
    playbooks: 'Playbooks',
    pleaseAddPrompt: 'Please add a prompt',
    preparing: 'Preparing',
    proceed: 'Proceed',

    // R
    readyToShare: 'Sales Team Materials',
    remaining: 'remaining',
    remove: 'Remove',
    reject: 'Reject',
    replaceCoverImage: 'Replace cover image',
    reply: 'Reply',
    requests: 'Requests',

    // S
    save: 'Save',
    selectAllMedia: 'Select All Media',
    sent: 'Sent',
    showMorePeople: 'Show more people',
    skip: 'Skip',
    somethingWentWrong: 'Something went wrong',
    statusActivate: 'Activate',
    submit: 'Submit',
    submitFeedback: 'Submit feedback',
    syncUsersWithService: 'Sync Users with Service',

    // T
    tasks: 'Tasks',
    taskTracker: 'Task Tracker',
    topShelfVisibility: 'Top Shelf Visibility',
    tickets: {
        // Page titles and headers
        supportTickets: 'Support Tickets',
        manageAndTrackSupportRequests: 'Manage and track support requests',
        createNewTicket: 'Create New Ticket',
        updateTicket: 'Update Ticket',
        createTicket: 'Create Ticket',
        tickets: 'Tickets',
        viewTicket: 'View Ticket',
        ticketActivity: 'Ticket Activity',
        historyOfAllActions: 'History of all actions performed on this ticket',
        stageTimers: 'Stage Timers',
        currentStage: 'Current Stage',
        inCurrentStage: 'in current stage',
        started: 'Started',
        timeInEachStage: 'Time in Each Stage',
        stageHistory: 'Stage History',

        // Status labels
        readyToClaim: 'Ready to Claim',
        inProgress: 'In Progress',
        completed: 'Completed',
        archived: 'Archived',

        // Priority labels
        high: 'High',
        standard: 'Standard',
        highPriority: 'High Priority',

        // Table headers
        category: 'Category',
        priority: 'Priority',
        status: 'Status',
        submitter: 'Submitter',
        assignee: 'Assignee',
        created: 'Created',
        actions: 'Actions',
        view: 'View',
        description: 'Description',

        // Form placeholders and labels
        enterTicketTitle: 'Enter ticket title',
        describeIssueOrRequest: 'Describe your issue or request',
        describeIssueOrRequestMin: 'Describe your issue or request (minimum 50 characters)',
        minimumCharacters: 'Minimum {min} characters required',

        // Buttons and actions
        viewTicketButton: 'View ticket',
        claim: 'Claim',
        complete: 'Complete',
        reopen: 'Reopen',
        submitTicket: 'Submit Ticket',

        // Form validation
        titleRequired: 'Title is required',
        categoryRequired: 'Category is required',
        descriptionRequired: 'Description is required',
        descriptionMinLength: 'Description must be at least {min} characters long',

        // Messages
        noTicketsFound: 'No tickets found',
        noTicketsDescription: 'There are no tickets to display at the moment.',
        createYourFirstTicket: 'Create your first ticket to get started.',
        noActivityRecorded: 'No activity recorded yet for this ticket.',
        unassigned: 'Unassigned',
        unknownUser: 'Unknown User',
        myTickets: 'My Tickets',
        allTickets: 'All Tickets',

        // Form actions
        updating: 'Updating...',
        creating: 'Creating...',
        updateTicketInformation: 'Update ticket information',
        submitNewSupportTicket: 'Submit a new support ticket for assistance',

        // Success/Error messages
        ticketUpdatedSuccessfully: 'Ticket updated successfully',
        ticketCreatedSuccessfully: 'Ticket created successfully',
        failedToSaveTicket: 'Failed to save ticket. Please try again.',
        loadingUsers: 'Loading users...',

        // Stage names
        ready: 'Ready',
        inProgress: 'In Progress',
        completed: 'Completed',
        archived: 'Archived',

        // Log messages
        from: 'From:',
        to: 'To:',
        active: 'Active',
        duration: 'Duration',
        by: 'by',

        // Status change messages
        changeStatus: 'Change Status',
        confirmStatusChange: 'Do you want to change ticket status to {status}?',
        statusUpdated: 'Ticket status updated successfully',

        // Filter labels
        assignedToMe: 'Assigned to me',
        createdByMe: 'Created by me',

        // Status tab labels
        readyToClaim: 'Ready to Claim',
        inProgress: 'In Progress',
        completed_last_72_hours: 'Completed (Last 72 hours)',
        completed: 'Completed',
        archived: 'Archived',

        // File attachments
        attachments: 'Attachments',
        addFiles: 'Add Files',
        uploading: 'Uploading...',
        noAttachments: 'No attachments uploaded yet',
        uploadFiles: 'Upload Files',
        fileUploaded: 'File uploaded successfully',
        fileDeleted: 'File deleted successfully',
        uploadFailed: 'Upload failed',
        deleteFailed: 'Delete failed',
        downloadFile: 'Download file',

        // File deletion modal
        deleteFile: {
            title: 'Delete File',
            text: 'Are you sure you want to delete this file? This action cannot be undone.',
            buttonCancel: 'Cancel',
            buttonSubmit: 'Delete File',
        },

        // File upload messages
        fileUploadProgress: 'Uploading {filename}...',
        fileUploadComplete: '{filename} uploaded successfully',
        fileUploadError: 'Failed to upload {filename}',
        fileSizeLimit: 'File size limit exceeded',
        unsupportedFileType: 'Unsupported file type',
        maxFilesReached: 'Maximum number of files reached',

        // File types
        imageFile: 'Image file',
        documentFile: 'Document file',
        videoFile: 'Video file',
        audioFile: 'Audio file',
        otherFile: 'Other file',

        // File log messages
        fileUploaded: 'uploaded file',
        fileDeleted: 'deleted file',
        fileDownloaded: 'downloaded file',

        // File activity messages
        fileActivity: 'File Activity',
        noFileActivity: 'No file activity recorded yet',
        fileUploadedBy: 'File uploaded by',
        fileDeletedBy: 'File deleted by',
        fileDownloadedBy: 'File downloaded by',
    },
    title: 'Title',
    trimAndUpload: 'Trim & Upload',
    trimVideo: 'Trim video',

    // U
    update: 'Update',
    updating: 'Updating...',
    upload: 'Upload',
    uploadImage: 'Upload image',
    uploadPhoto: 'Upload photo',
    usersEditDividerTitle: 'Profile picture',

    // V
    videoTracker: 'Video Tracker',
    videoTrackerDescription: 'Follow every video you\'ve sent to the editing team, from request through to delivery.',
    viewMore: 'View More',
    viewing: 'viewing',
    visibilityAuthority: 'Visibility Authority',
    visibilityZone: 'Visibility Zone',
    visibilityZones: 'Visibility Zones',
    zoneVisibility: 'Zone Visibility',

    // Y
    yes: 'Yes',
    yesDeactivate: 'Yes, deactivate',

    // OVP Video Types
    ovp: {
        videoTypes: {
            mediaDay: {
                title: 'Media Day',
                text: 'High-impact, on-site content experience kickoff.'
            },
            event: {
                title: 'Event',
                text: 'Trade Show or Company event.'
            },
            facilityTour: {
                title: 'Facility Tour',
                text: 'Operational insights.'
            },
            productVideo: {
                title: 'Product Video',
                text: 'Demo and launch.'
            },
            onlineLearning: {
                title: 'Online Learning',
                text: 'Teaching and training.'
            },
            testimonial: {
                title: 'Testimonial',
                text: 'Client experiences.'
            },
            caseStudy: {
                title: 'Case Study',
                text: 'Showcase successes.'
            },
            cultureRecruiting: {
                title: 'Culture & Recruiting',
                text: 'Highlight culture.'
            }
        }
    }
}

